import { render, staticRenderFns } from "./test-portal-research-team.vue?vue&type=template&id=4c1f5d4b&"
import script from "./test-portal-research-team.vue?vue&type=script&lang=js&"
export * from "./test-portal-research-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-research-team.vue"
export default component.exports